import React from "react";
import './home.css';

// stack svgs imported from @stack folder
import { ReactComponent as PythonSVG } from '@stack/python.svg';
import { ReactComponent as SparkSVG } from '@stack/spark.svg';
import { ReactComponent as KubernetesSVG } from '@stack/kubernetes.svg';
import { ReactComponent as AwsSVG } from '@stack/aws.svg';
import { ReactComponent as GcpSVG } from '@stack/gcp.svg';

const Stack = () => {
    return (
        <div className="home__stack" >
            <div className="home__stack-content grid">
                <h3 className="home__stack-title">Stack</h3>
                <span className="home__stack-pipe"></span>
                <div className="home__stack-imgs">
                    <div className="home__stack-img"> <PythonSVG /> </div>
                    <div className="home__stack-img"><SparkSVG /></div>
                    <div className="home__stack-img"><KubernetesSVG /></div>
                    <div className="home__stack-img"><AwsSVG /></div>
                    <div className="home__stack-img"><GcpSVG /></div>
                </div>
            </div>
        </div>
    );
}

export default Stack;